import createLucideIcon from '../createLucideIcon';

const Terminal = createLucideIcon('Terminal', [
  ['polyline', { points: '4 17 10 11 4 5', key: 'akl6gq' }],
  ['line', { x1: '12', x2: '20', y1: '19', y2: '19', key: 'q2wloq' }],
]);

export default Terminal;
